import { EmptyState } from '@repo/common/components';
import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router';
import { BiDashboardPageController } from '../../features/BiDashboard';
import { useFeatureFlags } from '../../utils/featureFlags';
import { useParamsIdSuffixUuid } from '../../utils/hook/utils';

const BIDashboardPage = observer(() => {
	const id = useParamsIdSuffixUuid();
	const { biDashboardsEnabled } = useFeatureFlags();

	const navigate = useNavigate();

	if (!biDashboardsEnabled) {
		return (
			<EmptyState
				title="Dashboards are not enabled"
				description="Please contact your administrator to enable Dashboards"
				illustrationName="upgrade"
				includeGoBack={false}
				stateHeight="50vh"
				size="lg"
			/>
		);
	}

	const onMetricHeaderClick = (metricId: string) => {
		navigate(`/bi/metric/${metricId}?dashboardId=${id}`);
	};
	return (
		<BiDashboardPageController
			id={id}
			mode="page"
			onMetricHeaderClick={onMetricHeaderClick}
		/>
	);
});

export default BIDashboardPage;
